import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { mq } from '@utils/responsive';
import { CONTENT_MAX_WIDTH, ORIENTATION_RATIOS, getImageHeight } from '@utils/space';
import Image from '@components/Image';

const Box = styled.div`
  width: ${(props) => Math.round(props.$heights.mobile * props.$ratio)}px;
  max-width: 100%;

  ${mq.gtmd`
    width: ${(props) => Math.round(props.$heights.desktop * props.$ratio)}px;
    max-width: min(100%, ${CONTENT_MAX_WIDTH}px);
  `}
`;

function SizedImage({ children, className, fluid, imageHeight, orientation, ...rest }) {
  const heights = getImageHeight(imageHeight);
  const aspectRatio = ORIENTATION_RATIOS[orientation] || (fluid && fluid.aspectRatio) || 1;

  if (!heights) {
    return null;
  }

  return (
    <Box className={className} $heights={heights} $ratio={aspectRatio}>
      <Image fluid={fluid} ratio={1 / aspectRatio} {...rest} />
      {children}
    </Box>
  );
}

SizedImage.propTypes = {
  fluid: PropTypes.object.isRequired,
  imageHeight: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
  orientation: PropTypes.oneOf(['portrait', 'album']),
};

export default SizedImage;
